/**
 * API endpoints for tag-related operations
 */
export const GP_TAG_ENDPOINTS = {
  tags: 'api/v2/tags',
  entityTags: 'api/v2/tags/entity',
} as const;
